




































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations, Buttons } from '@/ts/store/Constants';
import SharedFacilities from '@/components/User/SharedFacilities/AvailableSharedFacilities.vue';
import BookedSharedFacilities from '@/components/User/SharedFacilities/BookedSharedFacilities.vue';
import FacilityDetailsOverlay from '@/components/User/SharedFacilities/FacilityDetailsOverlay.vue';
import BookFacilityOverlay from '@/components/User/SharedFacilities/BookFacilityOverlay.vue';
import BookedFacilityOverlay from '@/components/User/SharedFacilities/BookedFacilityOverlay.vue';
import BookFacilityTimeOverlay from '@/components/User/SharedFacilities/BookFacilityTimeOverlay.vue';
import BookFacilityDateOverlay from '@/components/User/SharedFacilities/BookFacilityDateOverlay.vue';

@Component({
    components: {
        SharedFacilities,
        BookedSharedFacilities,
        FacilityDetailsOverlay,
        BookFacilityOverlay,
        BookedFacilityOverlay,
        BookFacilityTimeOverlay,
        BookFacilityDateOverlay,
    },
    computed: {
        ...mapGetters({
            facilityDetailsOverlayVisibility: 'SharedFacilities/getFacilityDetailsOverlayVisibility',
            bookFacilityOverlayVisibility: 'SharedFacilities/getBookFacilityOverlayVisibility',
            bookedFacilityOverlayVisibility: 'SharedFacilities/getBookedFacilityOverlayVisibility',
            bookFacilityTimeOverlayVisibility: 'SharedFacilities/getBookFacilityTimeOverlayVisibility',
            bookFacilityDateOverlayVisibility: 'SharedFacilities/getBookFacilityDateOverlayVisibility',
        }),
    },
})
export default class UserSharedFacilities extends Vue {
    public tabs = [
        { name: this.$t('general.shared-facilities', 'Shared Facilities'), component: 'SharedFacilities' },
        { name: this.$t('general.my-bookings', 'My bookings'), component: 'BookedSharedFacilities' },
    ];
    public activeTab: number = 0;

    constructor() {
        super();
    }

    @Watch('activeTab')
    public activeTabChanged() {
        if (this.defaultTab !== null) {
            this.$store.commit(Mutations.SET_FACILITY_PAGE_DEFAULT_TAB, null);
        }
    }

    @Watch('defaultTab')
    public defaultTabChanged() {
        if (this.defaultTab !== null) {
            this.changePageTab(this.defaultTab);
        }
    }

    get defaultTab() {
        return this.$store.getters['SharedFacilities/getFacilityPageDefaultTab'];
    }

    get currentTabView() {
        return this.tabs[this.activeTab].component;
    }

    public changePageTab(index: number) {
        this.activeTab = index;
    }

    public created() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('general.shared-facilities', 'Shared facilities'));
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.None);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.None);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }

    public mounted() {
        const bookingId = this.$route.query.bookingId;
        const tabIndex = this.$route.params.tabIndex;

        if (tabIndex !== undefined) {
            this.changePageTab(Number(tabIndex));
        }

        if (typeof bookingId !== 'undefined') {
            this.changePageTab(1);
        }
    }
}
